import FormatCurrency from 'components/Common/FormatCurrency'
import type { ImageParams } from 'components/Common/ResponsiveImage/ResponsiveImage'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LoyaltyTierBenefitAvailabilityMessageBanner from 'loyalty/components/LoyaltyTierBenefitAvailabilityMessageBanner'
import useLoyaltyUserBenefitView from 'loyalty/hooks/useLoyaltyUserBenefitView'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalImageThumbnail from 'LuxKit/Modal/ModalImageThumbnail'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { useMemo } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

const imageParams: ImageParams = {
  aspectRatio: '16:8',
  mobileWidth: '720px',
  fit: 'center',
}

function LandingPageLoyaltyTravelShootCreditBenefitsModal() {
  const intl = useIntl()
  const benefitView = useLoyaltyUserBenefitView('travelshoot_credit')
  const benefitValue = benefitView?.benefit.value?.amount ?? 0
  const image = useMemo<App.Image>(() => ({
    id: 'r1z816jjifeqb5hwk50o',
    title: intl.formatMessage({
      id: 'sj_JEhZNdrlz5RwEG5zk',
      defaultMessage: 'Pro photos on your trip',
      description: 'Alternative text fallback for the Travelshoot loyalty benefit image',
    }),
  }), [intl])

  return (
    <ModalBase size="L">
      <ModalHeader title={intl.formatMessage({
        id: 'hybNTXIZ6KwkPvX_Nf-J',
        defaultMessage: 'Pro photos on your trip',
        description: 'Title for the Travelshoot photo credit benefit details modal',
      })}
      />
      <ModalBody>
        <ModalImageThumbnail image={image} imageParams={imageParams} />
        <ModalContent>
          <VerticalSpacer gap={32}>
            <LoyaltyTierBenefitAvailabilityMessageBanner benefitType="travelshoot_credit" />
            <BodyText variant="large">
              {intl.formatMessage({
                id: '6DypOsT16_AElqB5EoF1',
                defaultMessage: 'Make the memories last. Use your Travelshoot voucher to book a professional photo session at your destination—perfect for couples, families, or solo travellers.',
                description: 'Description of the Travelshoot photo credit benefit in the details modal',
              })}
            </BodyText>
            <VerticalSpacer gap={8}>
              <Heading variant="heading4">{intl.formatMessage({
                id: 'fVYTrRZ67PgK_ypaHrNb',
                defaultMessage: 'How it works',
                description: 'Section heading explaining how the Travelshoot photo credit benefit works',
              })}
              </Heading>
              <BodyText variant="large">
                <FormattedMessage
                  id="NwA_LuWDQkhIp21SBU47"
                  defaultMessage="Book a professional photoshoot at your holiday destination through Travelshoot.{br}{br}Choose your location, match with a local photographer, and capture unforgettable moments with a one-hour shoot. Within 48 hours you’ll receive a couple sneak peeks and the full album within 7 days.{br}{br}Use your {voucherAmount} voucher at checkout and receive a gallery of professionally edited photos to keep forever.{br}{br}A Travelshoot can be booked on its own (doesn’t need to be attached to a hotel booking) and our friendly customer service team can organise your voucher post-booking."
                  description="Detailed explanation of the Travelshoot photo credit benefit and how to use it"
                  values={{
                    voucherAmount: <FormatCurrency value={benefitValue} format="dynamic" />,
                    br: <br />,
                  }}
                />
              </BodyText>
            </VerticalSpacer>
          </VerticalSpacer>
        </ModalContent>
      </ModalBody>
    </ModalBase>
  )
}

export default LandingPageLoyaltyTravelShootCreditBenefitsModal
